import React from 'react'
import {store, Provider, debug} from 'src/core/store'
import {RouteComponent} from 'src/core/router'
import { LocaleProvider } from 'antd'
import ZH from 'antd/lib/locale-provider/zh_CN'
import 'moment/locale/zh-cn'

// 注册全局store
export default class App extends React.Component {
  render() {
    debug()
    return (
      <Provider store={store}>
        <LocaleProvider locale={ZH}>
          <RouteComponent />
        </LocaleProvider>
      </Provider>

    )
  }
}



// WEBPACK FOOTER //
// ./core/app.js